import { usePagination } from "~/composables/paginations/usePagination";
import { GlobalEvaluationsTabEnum } from "~/utils/enums/evaluations.enums";
import { PaginationKeysEnum } from "~/utils/enums/pagination-keys.enums";

/** The Évaluations page's tab, which its list, its filters and its export follow; à chaud until one is picked. */
export function currentEvaluationsTab(): GlobalEvaluationsTabEnum {
  const tab = usePagination(PaginationKeysEnum.EVALUATIONS_PAGINATION).paginateOptions.value.filter;
  return (tab as GlobalEvaluationsTabEnum) || GlobalEvaluationsTabEnum.HOT;
}
